import React from "react";
import { FileDownloadOutlined, InfoOutlined } from "@mui/icons-material";
import INTERCOM_ARTICLES from "../../constants/intercomArticles";
import MixpanelService from "../utils/MixpanelService";

const DataSubmissionHelp = ({ ndcDownloadPath }) => {
  return (
    <div className="flex justify-content-end gap--8">
      {ndcDownloadPath && (
        <a href={ndcDownloadPath}>
          <div className="button button--lg button--white">
            <FileDownloadOutlined style={{ fontSize: "16px", verticalAlign: "text-bottom" }} /> NDC
            List
          </div>
        </a>
      )}
      <a href={INTERCOM_ARTICLES.HOW_TO_SUBMIT_CLAIMS} target="_blank">
        <div
          className="button button--lg button--white"
          onClick={() => {
            MixpanelService.track("esp_submissions_help_resources");
          }}
        >
          <InfoOutlined style={{ fontSize: "16px", verticalAlign: "text-bottom" }} /> Help Resources
        </div>
      </a>
    </div>
  );
};

export default DataSubmissionHelp;
